import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from "react-query";
import { useClientsState } from "atoms/clientsAtom";

import {
  addClientGroup,
  deleteClientGroup,
  editClientGroup,
  getClientGroups,
} from "./index";

const useOnSuccess = () => {
  const queryClient = useQueryClient();
  const { setClientsState } = useClientsState();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-client-groups"] });
    setClientsState((prev) => ({
      ...prev,
      activeGroupItem: null,
      activeItem: null
    }));
  };
};

export const useGetClientGroups = (
  options?:
    | Omit<UseQueryOptions<any, unknown, any, string[]>, "queryKey" | "queryFn">
    | undefined
) => {
  return useQuery(["get-client-groups"], getClientGroups, options);
};

export const useAddClientGroup = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["add-client-group"], addClientGroup, {
    onSuccess,
  });
};

export const useEditClientGroup = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["edit-client-group"], editClientGroup, {
    onSuccess,
  });
};

export const useDeleteClientGroup = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["delete-client-group"], deleteClientGroup, {
    onSuccess,
  });
};
